// extracted by mini-css-extract-plugin
export var compact = "_n5-2";
export var phoneFrame = "_n5-0";
export var phoneScreen = "_n5-1";